// import BreadCrumb from 'Common/BreadCrumb';
// import React, { FC, useEffect, useState } from 'react';
// import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
// import 'leaflet/dist/leaflet.css';

// // Fix لمشكلة الأيقونة الافتراضية (مهم جدًا)
// import L from 'leaflet';
// import iconUrl from 'leaflet/dist/images/marker-icon.png';
// import iconShadow from 'leaflet/dist/images/marker-shadow.png';
// import { useAppDispatch, useAppSelector } from '@redux/hooks';
// import { RootState } from '@redux/store';
// import { getMapThunk } from '@redux/features/map.slice';
// import ImportCustomersModal from './ImportCustomersModal';
// import UpdateDescriptionModal from './UpdateDescriptionModal';
// import ButtonBase from 'components/ui/buttons/ButtonBase';

// let DefaultIcon = L.icon({
//     iconUrl,
//     shadowUrl: iconShadow,
//     iconSize: [25, 41],
//     iconAnchor: [12, 41],
// });

// L.Marker.prototype.options.icon = DefaultIcon;

// const CustomersMap: FC = () => {
//     const dispatch = useAppDispatch();
//     const { map, loading } = useAppSelector((state: RootState) => state.mapState);

//     // Ensure customers is always an array
//     const customers = Array.isArray(map) ? map : [];

//     const [showImportModal, setShowImportModal] = useState(false);
//     const [showUpdateDescriptionModal, setShowUpdateDescriptionModal] = useState(false);
//     const [selectedCustomerId, setSelectedCustomerId] = useState<number | null>(null);

//     useEffect(() => {
//         dispatch(getMapThunk());
//     }, [dispatch]);

//     if (loading) {
//         return (
//             <>
//                 <div className="flex items-center justify-center min-h-[400px]">
//                     <div className="text-center">
//                         <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-custom-500"></div>
//                         <p className="mt-4 text-slate-500">Loading customers map data...</p>
//                     </div>
//                 </div>
//             </>
//         );
//     }

//     // Calculate center of all customers for initial view
//     const getMapCenter = () => {
//         if (!customers || customers.length === 0) {
//             return [40.7128, -74.006]; // Default to New York
//         }
//         const validCustomers = customers.filter(
//             (c: any) => c && c.latitude && c.longitude && !isNaN(c.latitude) && !isNaN(c.longitude)
//         );
//         if (validCustomers.length === 0) {
//             return [40.7128, -74.006];
//         }
//         const avgLat = validCustomers.reduce((sum: number, c: any) => sum + c.latitude, 0) / validCustomers.length;
//         const avgLng = validCustomers.reduce((sum: number, c: any) => sum + c.longitude, 0) / validCustomers.length;
//         return [avgLat, avgLng];
//     };

//     const handleOpenUpdateDescription = (customerId: number) => {
//         setSelectedCustomerId(customerId);
//         setShowUpdateDescriptionModal(true);
//     };

//     const handleCloseUpdateDescription = () => {
//         setShowUpdateDescriptionModal(false);
//         setSelectedCustomerId(null);
//     };

//     return (
//         <>
//             <BreadCrumb pageTitle=" Customers Map" />
//             <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
//                 <div className="card">
//                     <div className="card-body">
//                         <div className="flex justify-end gap-2 mb-4">
//                             <ButtonBase
//                                 innerText="Import Customers"
//                                 className="bg-primary hover:bg-primary-dark rounded border-none px-4 py-2 text-white"
//                                 onClick={() => setShowImportModal(true)}
//                             />
//                         </div>

//                         {customers && customers.length > 0 ? (
//                             <MapContainer
//                                 center={getMapCenter() as [number, number]}
//                                 zoom={customers.length > 1 ? 10 : 12}
//                                 style={{ height: '700px', width: '100%', borderRadius: '10px' }}
//                             >
//                                 <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

//                                 {customers
//                                     .filter(
//                                         (cust: any) =>
//                                             cust &&
//                                             cust.latitude != null &&
//                                             cust.longitude != null &&
//                                             !isNaN(cust.latitude) &&
//                                             !isNaN(cust.longitude)
//                                     )
//                                     .map((cust: any) => (
//                                         <Marker key={cust.id} position={[cust.latitude, cust.longitude]}>
//                                             <Popup closeOnClick={false}>
//                                                 <div className="p-2">
//                                                     <h6 className="font-semibold mb-2">{cust.name}</h6>
//                                                     <p className="text-sm text-gray-600 mb-2">ID: {cust.id}</p>
//                                                     <ButtonBase
//                                                         innerText="Update Description"
//                                                         className="bg-yellow-600 hover:bg-yellow-700 rounded border-none px-3 py-1 text-white text-sm"
//                                                         onClick={() => handleOpenUpdateDescription(cust.id)}
//                                                     />
//                                                 </div>
//                                             </Popup>
//                                         </Marker>
//                                     ))}
//                             </MapContainer>
//                         ) : (
//                             <div className="flex items-center justify-center min-h-[400px]">
//                                 <div className="text-center">
//                                     <p className="text-gray-500 mb-4">No customers found on the map</p>
//                                     <ButtonBase
//                                         innerText="Import Customers"
//                                         className="bg-primary hover:bg-primary-dark rounded border-none px-4 py-2 text-white"
//                                         onClick={() => setShowImportModal(true)}
//                                     />
//                                 </div>
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </div>

//             <ImportCustomersModal show={showImportModal} handleClose={() => setShowImportModal(false)} />
//             <UpdateDescriptionModal
//                 show={showUpdateDescriptionModal}
//                 handleClose={handleCloseUpdateDescription}
//                 customerId={selectedCustomerId}
//             />
//         </>
//     );
// };

// export default CustomersMap;
import React, { FC, useEffect, useMemo, useState } from "react";
import BreadCrumb from "Common/BreadCrumb";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import iconUrl from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";
import MarkerClusterGroup from "react-leaflet-cluster";

import { useAppDispatch, useAppSelector } from "@redux/hooks";
import { RootState } from "@redux/store";
import { getMapThunk } from "@redux/features/map.slice";

import ImportCustomersModal from "./ImportCustomersModal";
import UpdateDescriptionModal from "./UpdateDescriptionModal";
import ButtonBase from "components/ui/buttons/ButtonBase";

// إعداد الأيقونة الافتراضية للـ markers
const DefaultIcon = L.icon({
  iconUrl,
  shadowUrl: iconShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});
L.Marker.prototype.options.icon = DefaultIcon;

// 📍 Component منفصل للـ Markers (محسن للأداء)
const CustomersMarkers = React.memo(({ customers, onUpdate }: any) => {
  return (
    <MarkerClusterGroup chunkedLoading>
      {customers.map((cust: any) => (
        <Marker key={cust.id} position={[cust.latitude, cust.longitude]}>
          <Popup closeOnClick={false}>
            <div className="p-2">
              <h6 className="font-semibold mb-2">{cust.name}</h6>
              <h6 className="font-semibold mb-2">{cust.description}</h6>

              <p className="text-sm text-gray-600 mb-2">ID: {cust.id}</p>
              <ButtonBase
                innerText="Update Description"
                className="bg-yellow-600 hover:bg-yellow-700 rounded border-none px-3 py-1 text-white text-sm"
                onClick={() => onUpdate(cust.id)}
              />
            </div>
          </Popup>
        </Marker>
      ))}
    </MarkerClusterGroup>
  );
});

const CustomersMap: FC = () => {
  const dispatch = useAppDispatch();
  const { map, loading } = useAppSelector((state: RootState) => state.mapState);

  const [showImportModal, setShowImportModal] = useState(false);
  const [showUpdateDescriptionModal, setShowUpdateDescriptionModal] = useState(false);
  const [selectedCustomerId, setSelectedCustomerId] = useState<number | null>(null);

  useEffect(() => {
    dispatch(getMapThunk());
  }, [dispatch]);

  // ✅ التعامل مع الداتا بأمان
  const customers = useMemo(
    () =>
      Array.isArray(map)
        ? map.filter(
            (c: any) =>
              c &&
              c.latitude &&
              c.longitude &&
              !isNaN(c.latitude) &&
              !isNaN(c.longitude)
          )
        : [],
    [map]
  );

  const mapCenter = useMemo(() => {
    if (customers.length === 0) return [30.0444, 31.2357]; 
    const avgLat =
      customers.reduce((sum: number, c: any) => sum + c.latitude, 0) /
      customers.length;
    const avgLng =
      customers.reduce((sum: number, c: any) => sum + c.longitude, 0) /
      customers.length;
    return [avgLat, avgLng];
  }, [customers]);

  const handleOpenUpdateDescription = (customerId: number) => {
    setSelectedCustomerId(customerId);
    setShowUpdateDescriptionModal(true);
  };

  const handleCloseUpdateDescription = () => {
    setShowUpdateDescriptionModal(false);
    setSelectedCustomerId(null);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-custom-500"></div>
          <p className="mt-4 text-slate-500">Loading customers map data...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <BreadCrumb pageTitle="Customers Map" />
      <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
        <div >
          <div className="bg-white rounded-lg shadow p-4">
            <div className="flex justify-end gap-2 mb-4">
              <ButtonBase
                innerText="Import Customers"
                className="bg-primary hover:bg-primary-dark rounded border-none px-4 py-2 text-white"
                onClick={() => setShowImportModal(true)}
              />
            </div>

            {customers.length > 0 ? (
              <MapContainer
                center={mapCenter as [number, number]}
                zoom={customers.length > 1 ? 17 : 12}
                style={{
                  height: "700px",
                  width: "100%",
                  borderRadius: "10px",
                }}
                preferCanvas={true} 
              >
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                <CustomersMarkers
                  customers={customers}
                  onUpdate={handleOpenUpdateDescription}
                />
              </MapContainer>
            ) : (
              <div className="flex items-center justify-center min-h-[400px]">
                <div className="text-center">
                  <p className="text-gray-500 mb-4">
                    No customers found on the map
                  </p>

                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <ImportCustomersModal
        show={showImportModal}
        handleClose={() => setShowImportModal(false)}
      />
      <UpdateDescriptionModal
        show={showUpdateDescriptionModal}
        handleClose={handleCloseUpdateDescription}
        customerId={selectedCustomerId}
      />
    </>
  );
};

export default CustomersMap;

